module.exports = __webpack_public_path__ + "static/media/arrow-down.6c056294.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow-down.svg
// module id = 551
// module chunks = 0